import { render, staticRenderFns } from "./AdminVouchersScreen.vue?vue&type=template&id=3942b86a&scoped=true&"
import script from "./AdminVouchersScreen.vue?vue&type=script&lang=js&"
export * from "./AdminVouchersScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminVouchersScreen.vue?vue&type=style&index=0&id=3942b86a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3942b86a",
  null
  
)

export default component.exports